
import Logo from './components/Logo.vue'
import { defineComponent, onMounted } from 'vue'
import { useSigninEffect } from './hooks/useSigninEffect'
import request from '@/utils/request'
import {Dialog} from "vant";

export default defineComponent({
  name: 'Signin',
  components: {
    Logo
  },
  setup() {
    const { username, password, loading, onSubmit, checked, checkedShaky } =
      useSigninEffect()
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const backgroundBg = require('@/assets/login/bg.png')
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const buttonBg = require('@/assets/login/button.png')
    const tishi = () => {
      Dialog.alert({
        title: '提示',
        width: '320px',
        className: 'fontCss',
        messageAlign: 'left',
        message: '<span style="font-size: 16px;line-height: 1"><p>账号规则：用户名为学号</p><br>' +
            '<p>密码规则：15位身份证号码取最后6位为密码。18位身份证号码取去掉最后1位的倒数6位为密码( 即第12—第17位)，如输入密码无法登录，请尝试用学号作为初始密码。</p></span>',
        allowHtml:true
      })
    }
    onMounted(() => {
      request({
        url: '/destroyCookie',
        method: 'GET'
      }).then(res => {
        if (res.status) {
          console.log('cookise 清除成功')
        }
      })
    })
    return {
      username,
      password,
      loading,
      backgroundBg,
      buttonBg,
      onSubmit,
      tishi,
      checked,
      checkedShaky
    }
  }
})
